(() => {
  if (window.__danzCartAccessV03) return;
  window.__danzCartAccessV03 = true;

  const ALLOWED_COUNTRIES = ['WF','VU','TO','TV','TL','SB','PN','PG','NF','NU','NR','KI','PF','WS','TK','FJ','NC','CK','AU','NZ'];

  const root = () => document.querySelector('[data-danz-cart-access]');
  const bool = (value) => value === 'true';
  const state = () => {
    const el = root();
    return el ? {
      hasEducational: bool(el.dataset.hasEducational),
      hasLab: bool(el.dataset.hasLab),
      educationalPasscode: el.dataset.eduPasscode || '',
      labPasscode: el.dataset.labPasscode || '',
      partnerPasscode: el.dataset.partnerPasscode || ''
    } : null;
  };

  function setHidden(selector, hidden) {
    const el = document.querySelector(selector);
    if (el) el.hidden = hidden;
  }

  function rowTier(row) {
    return row ? (row.dataset.danzAccessTier || 'standard') : 'standard';
  }

  function configureRestrictedUI(cfg) {
    if (!cfg) return;
    const restricted = cfg.hasEducational || cfg.hasLab;
    setHidden('#DanzPasscodeSection', !restricted);
    setHidden('#DanzLabMessage', !cfg.hasLab);
    setHidden('#DanzEducationalMessage', cfg.hasLab || !cfg.hasEducational);
    setHidden('#DanzLabModalContent', !cfg.hasLab);
    setHidden('#DanzEducationalModalContent', cfg.hasLab || !cfg.hasEducational);
    setHidden('#DanzCheckoutButton', restricted);
  }

  function lockEducationalRow(row) {
    if (!row || rowTier(row) !== 'educational') return;
    const input = row.querySelector('input.quantity__input[name="updates[]"]');
    if (!input) return;
    input.value = '1';
    input.min = '1';
    input.max = '1';
    input.readOnly = true;
    row.querySelectorAll('.quantity__button').forEach((button) => { button.disabled = true; });
    const wrapper = input.closest('.cart-item__quantity-wrapper') || input.parentElement;
    if (wrapper && !wrapper.querySelector('.danz-edu-quantity-lock__note')) {
      const note = document.createElement('small');
      note.className = 'danz-edu-quantity-lock__note';
      note.textContent = 'Quantity is limited to one per verified student or teacher.';
      wrapper.appendChild(note);
    }
  }

  async function enforceEducationalQuantities() {
    const updates = {};
    document.querySelectorAll('[data-danz-cart-variant-id]').forEach((row) => {
      if (rowTier(row) !== 'educational') return;
      const qty = parseInt(row.dataset.danzCartQuantity || row.querySelector('input.quantity__input')?.value || '1', 10);
      const key = row.dataset.danzCartLineKey || row.querySelector('input.quantity__input')?.dataset.quantityLineKey;
      if (key && qty > 1) updates[key] = 1;
      lockEducationalRow(row);
    });
    if (sessionStorage.getItem('edu_access_tier') !== 'lab_packs' && Object.keys(updates).length) {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Unable to correct educational quantity');
      window.location.reload();
      return true;
    }
    return false;
  }

  function unlockEducationalQuantities() {
    document.querySelectorAll('[data-danz-cart-variant-id]').forEach((row) => {
      if (rowTier(row) !== 'educational') return;
      const input = row.querySelector('input.quantity__input[name="updates[]"]');
      if (input) {
        input.readOnly = false;
        input.removeAttribute('max');
        row.querySelectorAll('.quantity__button').forEach((button) => { button.disabled = false; });
      }
      const note = row.querySelector('.danz-edu-quantity-lock__note');
      if (note) note.hidden = true;
    });
  }

  function showCheckoutGate() { setHidden('#DanzCheckoutGate', false); }
  function unlockCheckout() { setHidden('#DanzPasscodeSection', true); setHidden('#DanzCheckoutButton', false); }

  function restoreAccessState(cfg) {
    const tier = sessionStorage.getItem('edu_access_tier');
    if (tier === 'lab_packs') {
      unlockCheckout();
      unlockEducationalQuantities();
    } else if (!cfg.hasLab && cfg.hasEducational && tier === 'educational') {
      unlockCheckout();
    }
  }

  function handleGeoResult(countryCode, cfg) {
    const geo = document.querySelector('#DanzGeoBlockSection');
    if (ALLOWED_COUNTRIES.includes(countryCode) || sessionStorage.getItem('geo_bypass') === '1') {
      if (geo) geo.hidden = true;
      showCheckoutGate();
      restoreAccessState(cfg);
    } else {
      if (geo) geo.hidden = false;
      setHidden('#DanzCheckoutGate', true);
    }
  }

  async function init() {
    const cfg = state();
    if (!cfg) return;
    configureRestrictedUI(cfg);
    const reloading = await enforceEducationalQuantities().catch((error) => {
      console.error('[3D ANZ] Educational quantity protection failed.', error);
      return false;
    });
    if (reloading) return;
    const detectedCountry = window.Shopify && window.Shopify.country ? window.Shopify.country : 'XX';
    handleGeoResult(detectedCountry, cfg);
  }

  document.addEventListener('click', (event) => {
    const cfg = state();
    if (!cfg) return;
    const overlay = document.querySelector('#DanzEduModalOverlay');

    if (event.target.closest('#DanzShowEduModal') && overlay) {
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      return;
    }
    if ((event.target.closest('#DanzCloseEduModal') || event.target === overlay) && overlay) {
      overlay.hidden = true;
      document.body.style.overflow = '';
      return;
    }

    if (event.target.closest('#DanzPasscodeSubmit')) {
      const input = document.querySelector('#DanzPasscodeInput');
      const error = document.querySelector('#DanzPasscodeError');
      const entered = input ? input.value.trim() : '';
      if (error) error.hidden = true;
      if (entered && entered === cfg.labPasscode) {
        sessionStorage.setItem('edu_access_tier', 'lab_packs');
        unlockCheckout();
        unlockEducationalQuantities();
      } else if (!cfg.hasLab && entered && entered === cfg.educationalPasscode) {
        sessionStorage.setItem('edu_access_tier', 'educational');
        unlockCheckout();
      } else if (error) {
        error.hidden = false;
      }
      return;
    }

    if (event.target.closest('#DanzPartnerPasscodeSubmit')) {
      const input = document.querySelector('#DanzPartnerPasscodeInput');
      const error = document.querySelector('#DanzPartnerPasscodeError');
      const entered = input ? input.value.trim() : '';
      if (entered && entered === cfg.partnerPasscode) {
        sessionStorage.setItem('geo_bypass', '1');
        if (error) error.hidden = true;
        handleGeoResult('AU', cfg);
      } else if (error) {
        error.hidden = false;
      }
    }
  });

  let queued = false;
  const observer = new MutationObserver(() => {
    if (!root() || queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      init();
    });
  });

  const start = () => {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
